import { request } from "@/network/request.js";


export function getHomeCarousel() {
    return request({
        url: "/wpindex/query/carousel",
        method:"GET"
    })
}

export function getHomeData(params) {
    return request({
        url: "/wpindex/query/all",
        params:params,
        method:"GET"
    })
}


export function getHomeFeature(params) {
    return request({
        url: "/wpindex/query/feature",
        params:params,
        method:"GET"
    })
}



export function postHomeData(data) {
    return request({
      url: '/wpindex/preview/post',
      method: 'get',
      params:data
    })
}


export function getNavList(data) {
    return request({
      url: '/wpindex/query/leftcate',
      method: 'get',
      params:data
    })
}


export function getOldUrl(data) {
    return request({
      url: '/wpindex/postname',
      method: 'POSt',
      params:data
    })
}

export function bannerList(data) {
    return request({
      url: '/wpindex/query/banner',
      method: 'get'
    })
}

export function webconfigList(data) {
    return request({
      url: '/wpindex/query/webconfig',
      method: 'get'
    })
}
